"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderChunk = void 0;
var React = require("react");
var html_entities_1 = require("html-entities");
var defaultElementConverters_1 = require("./defaultElementConverters");
function renderChunk(chunk, index) {
  if (React.isValidElement(chunk)) {
    return defaultElementConverters_1.attachKey(chunk, index);
  }
  if (typeof chunk === 'string') {
    return html_entities_1.AllHtmlEntities.decode(chunk);
  }
  return chunk;
}
exports.renderChunk = renderChunk;